<template>
  <MenuUserBox v-if="showMore" class="mb-15" @show-more="toggleUserMenu"/>
  <transition name="drop-down" v-if="isMobile">
    <nav v-if="showUserMenu" :class="[display, 'menu']">
      <ul>
        <li class="menu-item" v-for="(nav, i) of mainMenu" :key="i">
          <div v-if="nav.subMenu && nav.hasRole">
            <div
              class="menu-link w6"
              @click="showSubMenu">
              <div v-if="display === 'vertical'" class="menu-icon">
                <img :src="nav.icon" alt=""/>
              </div>
              <span>{{ nav.title }}</span>
              <button class="btn-dropdown ml-auto">
                <img
                  :class="showSubMenuUserAccount ? 'rotate-icon' : ''"
                  src="@/assets/images/dropdown-right.svg" alt="" style="width: 7px"/>
              </button>
            </div>
            <ul class="sub-menu-sp" v-if="showSubMenuUserAccount">
              <li class="menu-item" v-for="(navSub, i) of nav.subMenu" :key="i"
                  @click="onCloseSubMenu">
                <router-link
                  class="menu-link w6"
                  :to="{ name: navSub.routerName }"
                  :exact="navSub.exact"
                >
                  <div v-if="display === 'vertical'" class="menu-icon icon-item-sub_active">
                    <img :src="navSub.iconActive"/>
                  </div>
                  <div v-if="display === 'vertical'" class="menu-icon icon-item-sub_inactive">
                    <img :src="navSub.iconInActive"/>
                  </div>
                  <span>{{ navSub.title }}</span>
                </router-link>
              </li>
            </ul>
          </div>
          <div v-else @click="onClose">
            <router-link
              class="menu-link w6"
              :to="{ name: nav.routerName }"
              :exact="nav.exact"
              v-if="nav.hasRole"
            >
              <div v-if="display === 'vertical'" class="menu-icon">
                <img :src="nav.icon" :alt="nav.title"/>
              </div>
              <span>
              {{ nav.title }}
            </span>
            </router-link>
          </div>
        </li>
      </ul>
    </nav>
  </transition>
  <transition name="drop-down" v-else>
    <nav v-if="showUserMenu" :class="[display, 'menu']">
      <ul>
        <li class="menu-item" v-for="(nav, i) of mainMenu" :key="i" @click="onClose">
          <router-link
            class="menu-link w6"
            :to="{ name: nav.routerName }"
            :exact="nav.exact"
            v-if="nav.hasRole"
          >
            <div v-if="display === 'vertical'" class="menu-icon">
              <img :src="nav.icon" :alt="nav.title"/>
            </div>
            <span>
              {{ nav.title }}
            </span>
          </router-link>
        </li>
      </ul>
    </nav>
  </transition>
  <SubMenu v-if="showMore" :subMenu="subMenu" :hasIcon="showMore"/>
</template>

<script>
import { MAIN_MENU, SUB_MENU } from '@/constants/common';
import { mapGetters } from 'vuex';
import SubMenu from '@/components/SubMenu.vue';

export default {
  components: {
    SubMenu,
  },
  props: {
    display: {
      type: String,
      default: 'horiz',
    },
  },

  data() {
    return {
      showSubMenuUserAccount: false,
      mainMenu: MAIN_MENU,
      subMenu: SUB_MENU,
      showUserMenu: true,
      permissions: [],
    };
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    showMore() {
      return this.display === 'vertical';
    },
    ...mapGetters({
      userPermission: 'user/userPermission',
    }),
  },

  created() {
    if (Array.isArray(this.userPermission)) {
      this.userPermission.forEach((item) => {
        if (item.module_name && item.value !== 2 && this.permissions.indexOf(item.module_name) === -1) {
          this.permissions.push(item.module_name);
        }
      });
    }
    this.setRoleMainMenu();
  },
  // watch: {
  //   userPermission: {
  //     deep: true,
  //     handle() {
  //       this.permissions = [];
  //       if (Array.isArray(this.userPermission)) {
  //         this.userPermission.forEach((item) => {
  //           if (item.module_name && item.value !== 2 && this.permissions.indexOf(item.module_name) === -1) {
  //             this.permissions.push(item.module_name);
  //           }
  //         });
  //       }
  //       this.setRoleMainMenu();
  //     }
  //   },
  // },

  methods: {
    onCloseSubMenu() {
      this.showSubMenuUserAccount = true;
      this.$store.commit('common/SET_SHOW_SIDE_MENU', false);
    },
    showSubMenu() {
      if (this.showSubMenuUserAccount === true) {
        this.showSubMenuUserAccount = false;
      } else {
        this.showSubMenuUserAccount = true;
      }
    },
    async onClose() {
      this.$store.commit('common/SET_SHOW_SIDE_MENU', false);
    },
    toggleUserMenu() {
      if (this.display === 'vertical') {
        this.showUserMenu = !this.showUserMenu;
      }
    },
    async getUserPermission() {
      await this.$store.dispatch('user/getPermission');
    },
    getPathByRouteName(routerName) {
      if (!routerName) return false;
      const route = this.$router.resolve({
        name: routerName,
      });
      if (route) return route.meta.permission;
      return false;
    },
    setRoleMainMenu() {
      this.mainMenu = this.mainMenu.map((item) => {
        item.hasRole = false;
        const metaModule = item.meta;
        if (this.permissions.length === 0) {
          const checkPermission = this.userPermission.filter(permission => metaModule === permission.module_name);
          if (checkPermission.length > 0) {
            item.hasRole = checkPermission[0].value !== 2;
          } else {
            item.hasRole = true;
          }
        } else if (metaModule) {
          item.hasRole = this.permissions.indexOf(metaModule) !== -1;
        } else {
          item.hasRole = true;
        }
        return item;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/menu.scss';
</style>
